<template>
  <v-main>
    <v-container fluid>
      <!-- Header -->
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <v-btn icon @click="$router.go(-1)" class="mr-2">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <h3 class="font-weight-bold">Spin History</h3>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>

      <!-- Loading -->
      <v-row v-if="isLoading">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- History Table -->
      <v-row v-else>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Date & Time</th>
                      <th class="text-left">Wheel</th>
                      <th class="text-left">Reward</th>
                      <th class="text-left">Won</th>
                      <th class="text-left">Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(spin, i) in spins" :key="`spin_${i}`">
                      <td>
                        {{ formatDate(spin.created_at) }}
                      </td>
                      <td>
                        <v-chip small outlined color="primary">
                          <v-icon small left>mdi-ferris-wheel</v-icon>
                          {{ spin.wheel ? spin.wheel.name : "N/A" }}
                        </v-chip>
                      </td>
                      <td>
                        <div class="d-flex align-center">
                          <div
                            v-if="spin.item && spin.item.color"
                            :style="{
                              backgroundColor: spin.item.color,
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              marginRight: '8px',
                            }"
                          ></div>
                          <strong>
                            {{ spin.item ? spin.item.reward_name : "Unknown" }}
                          </strong>
                        </div>
                      </td>
                      <td>
                        <span
                          v-if="spin.reward_value > 0"
                          class="success--text font-weight-bold"
                        >
                          <v-icon small color="amber">mdi-coin</v-icon>
                          +{{ spin.reward_value }}
                        </span>
                        <span v-else class="text--secondary">-</span>
                      </td>
                      <td>
                        <span class="error--text">
                          <v-icon small color="amber">mdi-coin</v-icon>
                          -{{ spin.cost }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <div v-if="spins.length === 0" class="text-center pa-8">
                <v-icon size="64" color="grey lighten-2">mdi-history</v-icon>
                <p class="text-h6 mt-4 grey--text">No spin history yet</p>
                <v-btn color="primary" to="/lucky-wheels/spin">
                  Start Spinning
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Pagination -->
      <v-row v-if="!isLoading && spins.length > 0">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-pagination
                v-model="page"
                :length="totalPages"
                :total-visible="7"
                @input="getData"
                color="primary"
              ></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "LuckyWheelHistoryPage",
  data() {
    return {
      isLoading: false,
      spins: [],
      page: 1,
      rowsPerPage: 20,
      totalPages: 1,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      try {
        const response = await axios.get("/lucky-wheel/history", {
          params: {
            page: this.page,
            rowsPerPage: this.rowsPerPage,
          },
        });

        if (response.data.success) {
          this.spins = response.data.data;
          const count = response.data.count || 0;
          this.totalPages = Math.ceil(count / this.rowsPerPage);
        }
      } catch (error) {
        console.error("Error fetching history:", error);
      } finally {
        this.isLoading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleString();
    },
  },
};
</script>
